<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card>
          <ValidationObserver ref="form" v-slot="{ passes }">
            <v-form @submit.prevent="passes(filtergrid)" class="mb-5">
              <v-card>
                <v-expansion-panels v-model="panel" multiple focusable>
                  <v-expansion-panel>
                    <v-expansion-panel-header>{{
                      $t("language.filter")
                    }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container grid-list-xl>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md3>
                              <v-autocomplete
                                dense
                                v-model="grid.filter.departmentid"
                                :items="DepartmentList"
                                item-text="name"
                                item-value="id"
                                :label="$t('language.department')"
                                :clearable="true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-autocomplete
                                dense
                                v-model="grid.filter.branchid"
                                :items="BranchList"
                                item-text="name"
                                item-value="id"
                                :label="$t('language.branch')"
                                :clearable="true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-autocomplete
                                dense
                                v-model="grid.filter.personid"
                                :items="PersonList"
                                item-text="name"
                                item-value="id"
                                :label="$t('language.person')"
                                :clearable="true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm12 md3>
                              <ValidationProvider
                                :name="$t('language.fromdate')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <eng-nep-date-picker
                                  :error-messages="errors[0]"
                                  v-model="grid.filter.fromdate"
                                  :label="$t('language.fromdate')"
                                ></eng-nep-date-picker>
                              </ValidationProvider>
                            </v-flex>
                            <v-flex xs12 sm12 md3>
                              <ValidationProvider
                                :name="$t('language.todate')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <eng-nep-date-picker
                                  :error-messages="errors[0]"
                                  v-model="grid.filter.todate"
                                  :label="$t('language.todate')"
                                ></eng-nep-date-picker>
                              </ValidationProvider>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          dense
                          color="general"
                          class="mr-2"
                          light
                          type="submit"
                          >{{ $t("language.filter") }}</v-btn
                        >
                        <v-btn dense class="mr-2" light @click="resetFilter">{{
                          $t("language.clear")
                        }}</v-btn>
                        <v-btn dense color="general" light @click="newItem">{{
                          $t("language.new")
                        }}</v-btn>
                      </v-card-actions>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-form>
          </ValidationObserver>
          <v-dialog v-model="dialog" max-width="600px">
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-title>{{
                    $t("language.attendanceposting")
                  }}</v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <ValidationProvider
                            :name="$t('language.person')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.personalid"
                              :items="PersonList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.person')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.indate')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <eng-nep-date-picker
                              :error-messages="errors[0]"
                              v-model="vModel.indate"
                              :label="$t('language.indate')"
                            ></eng-nep-date-picker>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.intime')"
                            :rules="vModel.outtime == null || vModel.outtime == '' ? 'required|time' : 'time'"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="vModel.intime"
                              autocomplete="off"
                              :label="$t('language.intime')"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.outdate')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <eng-nep-date-picker
                              :error-messages="errors[0]"
                              v-model="vModel.outdate"
                              :label="$t('language.outdate')"
                            ></eng-nep-date-picker>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.outtime')"
                            :rules="vModel.intime == null || vModel.intime == '' ? 'required|time' : 'time'"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="vModel.outtime"
                              autocomplete="off"
                              :label="$t('language.outtime')"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                        <v-flex
                          v-if="$store.getters.settings.enablebreakinbreakout"
                          xs12
                          sm12
                          md4
                        >
                          <ValidationProvider
                            :name="$t('language.breakout')"
                            rules="required|time"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="vModel.breakout"
                              autocomplete="off"
                              :label="$t('language.breakout')"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                        <v-flex
                          v-if="$store.getters.settings.enablebreakinbreakout"
                          xs12
                          sm12
                          md4
                        >
                          <ValidationProvider
                            :name="$t('language.breakin')"
                            rules="required|time"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="vModel.breakin"
                              autocomplete="off"
                              :label="$t('language.breakin')"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <ValidationProvider
                            :name="$t('language.remarks')"
                            :rules="'required'"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              dense
                              v-model="vModel.remarks"
                              :label="$t('language.remarks')"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      dense
                      color="grey darken-1"
                      text
                      @click="closedialog"
                      >{{ $t("language.cancel") }}</v-btn
                    >
                    <v-btn
                      v-if="!isEdit"
                      color="green darken-1"
                      @click="passes(saveandreset)"
                      text
                      type="button"
                      >{{ $t("language.saveandreset") }}</v-btn
                    >
                    <v-btn dense color="blue darken-1" text type="submit">{{
                      $t("language.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-dialog>

          <v-data-table
            :headers="grid.headers"
            :items="grid.body"
            :search="grid.search"
            :options.sync="grid.options"
            :server-items-length="grid.total"
            :loading="grid.loading"
            :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
            class="elevation-2"
          >
            <template v-slot:header.person>
              <span>{{ $t("language.person") }}</span>
            </template>
            <template v-slot:header.indate>
              <span>{{ $t("language.indate") }}</span>
            </template>
            <template v-slot:header.intime>
              <span>{{ $t("language.intime") }}</span>
            </template>
            <template v-slot:header.outdate>
              <span>{{ $t("language.outdate") }}</span>
            </template>
            <template v-slot:header.outtime>
              <span>{{ $t("language.outtime") }}</span>
            </template>
            <template v-slot:item.indate="{ item }">
              {{getDefaultDate(item.indate)}}
            </template>
            <template v-slot:item.outdate="{ item }">
              {{getDefaultDate(item.outdate)}}
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)"
                >edit</v-icon
              >
              <v-icon v-if="$store.getters.role=='SUPERADMIN'" small @click="deleteItem(item.id)">delete</v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Base from "../../../shared/Base.vue";
import EngNepDatePicker from "../../../components/shared/EngNepDatePicker";
import TimePicker from "../../../components/shared/TimePicker";
import commonservice from "../../../shared/common.service";
export default {
  name: "attendancepostingview",
  extends: Base,
  components: {
    EngNepDatePicker,
    TimePicker,
  },
  data() {
    return {
      panel: [1],
      DepartmentList: [],
      BranchList: [],
      PersonList: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/posting/attendances/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.PersonList = response.data.persons;
      });
    });
  },
  created() {
    this.resetFilter();
    this.grid.headers = [
      { value: "person" },
      { value: "indate" },
      { value: "intime" },
      { value: "outdate" },
      { value: "outtime" },
      { value: "action", sortable: false },
    ];
    this.vModel = {
      id: null,
      personalid: null,
      indate: moment().format("YYYY-MM-DD"),
      intime: null,
      outdate: moment().format("YYYY-MM-DD"),
      outtime: null,
      breakout: null,
      breakin: null,
      remarks: null
    };
    this.url = "client/posting/attendances";
    this.panel = [...Array(1).keys()].map((k, i) => i);
  },
  methods: {
    resetFilter() {
      this.grid.filter = {
        fromdate: moment().format("YYYY-MM-DD"),
        todate: moment().format("YYYY-MM-DD"),
        branchid: null,
        departmentid: null,
        personid: null,
      };
      //this.grid.loadoninit = false;
      this.grid.body = [];
      this.grid.total = 0;
    },
  },
};
</script>
